import {
  CustomForm,
  CustomFormPageFieldUuidToFileEntitiesMap,
  CustomFormPageFieldUuidToSignatureBase64Map,
  FpCompany,
  User
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  id: string;
  token: string;
}

interface ResponseDataType {
  can_manage_form_files: boolean;
  user: User;
  company: FpCompany;
  form_has_files: boolean;
  form_has_image_files: boolean;
  form: CustomForm;
  page_field_uuid_to_signature_base64_map: CustomFormPageFieldUuidToSignatureBase64Map;
  page_field_uuid_to_file_entities_map: CustomFormPageFieldUuidToFileEntitiesMap;
}

export const getCustomFormRequest = ({ id, token }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form/${ id }`, {
    token,
  });
};